import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { openPlanStartModal } from '@/module/payment/shared/modal/openPlanFeaturesModal';
import { markPromotionModalShown } from '@/shared/features/promotion-modal-state';
import { planStartAlertStorage } from '../storage';
import { type NotifyPlanStartProps } from '../types';
const PLAN_START_MODAL_DELAY_MS = 300;
export const NotifyPlanStartContainer = ({
  planType,
  startDate,
  endDate,
  eventType,
  isPaid,
  workspaceMemberType,
  planChangeVersion
}: NotifyPlanStartProps) => {
  const router = useRouter();
  useEffect(() => {
    // LTI 컨텍스트에서는 플랜 모달 표시하지 않음
    if (router.pathname.startsWith('/lti')) {
      return;
    }

    // FREE 플랜이면 무시
    if (planType === 'FREE') {
      return;
    }

    // 이미 모달을 표시했는지 확인
    if (!planStartAlertStorage.shouldShowModal()) {
      return;
    }

    // 휴대폰 인증 페이지에서는 모달 표시하지 않음
    // (인증 완료 후 플랜 관리(/profile/plan)로 이동하면 표시됨)
    if (router.pathname === '/verification-phone') {
      return;
    }

    // 플랜 시작 모달 표시 (딜레이 적용)
    const timer = setTimeout(() => {
      if (!planStartAlertStorage.shouldShowModal()) return;
      markPromotionModalShown();
      openPlanStartModal({
        planType,
        startDate,
        endDate,
        eventType,
        isPaid,
        isOwner: workspaceMemberType === 'OWNER'
      });
    }, PLAN_START_MODAL_DELAY_MS);
    return () => clearTimeout(timer);
  }, [router.pathname, planChangeVersion, planType, startDate, endDate, eventType, isPaid, workspaceMemberType]);
  return null;
};